import { View } from "react-native"
import { useTheme } from "styled-rn"
import { useContextSelector } from "use-context-selector"

import { HEADER_CONTENT_AREA } from "./PlayGameHeader"
import { useIsMobile } from "../../hooks/useIsMobile"
import { playGameContext } from "../../hooks/useSetupPlayGameContext"
import { BASE_PADDING, BodyText } from "../DesignSystem"

import { Theme } from "$consts/hostAPI"

export function PlayGameNetworkStatusBadge() {
  // If mobile, don't show 'connected'
  const isMobile = useIsMobile()
  const completed = useContextSelector(playGameContext, (s) => s.gameUIState.completeData.isComplete)
  const online = useContextSelector(playGameContext, (s) => s.gameUIState.isOnline)
  const networkState = useContextSelector(playGameContext, (s) => s.gameUIState.collab)

  if (completed) return null

  if (online === false) {
    return <SideLabel color="error">Offline</SideLabel>
  }

  if (networkState?.state === "error") {
    return <SideLabel color="error">Can't connect</SideLabel>
  }

  if (networkState?.state === "connecting") {
    return <SideLabel color="g_bgDark">Connecting...</SideLabel>
  }

  if (!isMobile && networkState?.state === "connected") {
    return <SideLabel>Playing together</SideLabel>
  }

  return null
}

const SideLabel = (props: { color?: keyof Theme; children: string }) => {
  const theme = useTheme()
  const color = props.color || "player"
  const isMobile = useIsMobile()

  return (
    <View
      style={{
        justifyContent: "center",
        paddingHorizontal: BASE_PADDING,
        paddingLeft: BASE_PADDING * 2,
        backgroundColor: theme[color],
        borderRadius: 9999,
        borderTopLeftRadius: isMobile ? 9999 : 0,
        borderBottomLeftRadius: isMobile ? 9999 : 0,
        height: HEADER_CONTENT_AREA,
      }}
    >
      <BodyText bold numberOfLines={1} size="small" customColorKey={"keyFG"}>
        {props.children}
      </BodyText>
    </View>
  )
}
